// frontend/src/components/FAQSection.js
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';

const FAQSection = () => {
    const [faqs, setFaqs] = useState([]);
    const [openId, setOpenId] = useState(null);

    useEffect(() => {
        axios.get('/api/invite/faq')
            .then(res => setFaqs(res.data))
            .catch(err => console.error('Ошибка загрузки FAQ', err));
    }, []);

    const toggle = (id) => {
        setOpenId(openId === id ? null : id);
    };

    if (faqs.length === 0) return null;

    return (
        <section className="py-16 sm:py-20 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
                    {/* Левая колонка – аккордеон */}
                    <div className="space-y-4">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                        >
                            <h2 className="text-4xl md:text-5xl font-display mb-3">Q&A</h2>
                            <p className="text-gray-600 text-lg">За это время мы получили некоторое количество одинаковых вопросов. В этой секции собрали ответы на самые типовые. С течением времени блок будет дополняться</p>
                        </motion.div>

                        <div className="space-y-3">
                            {faqs.map((faq) => (
                                <motion.div
                                    key={faq.id}
                                    className="border border-gray-200 rounded-xl overflow-hidden bg-white"
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                >
                                    <button
                                        onClick={() => toggle(faq.id)}
                                        className="w-full text-left px-6 py-4 flex items-center gap-4 hover:bg-gray-50 transition-colors"
                                    >
                                        <span className="flex-1 font-medium text-lg break-words">{faq.question}</span>
                                        <svg
                                            className={`w-5 h-5 flex-shrink-0 transform transition-transform ${openId === faq.id ? 'rotate-180' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </button>
                                    <AnimatePresence>
                                        {openId === faq.id && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: 'auto', opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.3 }}
                                                className="overflow-hidden"
                                            >
                                                <div className="px-6 pb-4 text-gray-600 border-t border-gray-100 pt-3">
                                                    {faq.answer}
                                                </div>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </motion.div>
                            ))}
                        </div>

                        <div className="mt-8 p-6 bg-gray-50 rounded-lg border border-gray-100">
                            <h3 className="text-xl font-medium text-gray-800 mb-3">Важная просьба</h3>
                            <p className="text-gray-600 leading-relaxed">
                                Пожалуйста, не передавайте и не публикуйте свою персональную ссылку на этот сайт.
                                Мы подготовили индивидуальные приглашения и хотим сохранить приватность как нашего праздника, так и каждого гостя.
                            </p>
                        </div>
                    </div>

                    {/* Правая колонка – фото */}
                    <motion.div
                        className="relative h-[500px] lg:h-[650px] rounded-3xl overflow-hidden shadow-2xl"
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <img
                            src="/images/registry-bg.jpg"
                            alt="FAQ"
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-l from-black/20 to-transparent" />
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;